export default __webpack_public_path__ + "static/media/logo.299bcb6c.jpg";